import { useEffect } from 'react'

const PropertyMap = (props: any) => {

	const searchData = props.autocomplete || {}

	const propertiesData = searchData?.properties?.slice(0,(10 - searchData?.team?.length - searchData?.suburbs?.length))
	const suburbsData = searchData?.suburbs?.slice(0,(10 - searchData?.team?.length))

	return (
		<div className='search-input'>
			{props.icon &&
				<div className='search-icon'>
					{props.icon}
				</div>
			}
			<input
				type="text"
				className={['form-control', props.icon ? 'search-with-icon' : ''].join(' ')}
				placeholder='Search, suburb, address or agent...'
				onChange={props.onChange}
				value={props.value}
			/>
			{props.value && (
				<button className='search-clear' onClick={props?.clearResults}>
					<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fillRule="evenodd" clipRule="evenodd" d="M4.4107 4.41076C4.73614 4.08533 5.26378 4.08533 5.58921 4.41076L9.99996 8.82151L14.4107 4.41077C14.7361 4.08533 15.2638 4.08533 15.5892 4.41077C15.9147 4.7362 15.9147 5.26384 15.5892 5.58928L11.1785 10L15.5892 14.4108C15.9147 14.7362 15.9147 15.2638 15.5892 15.5893C15.2638 15.9147 14.7361 15.9147 14.4107 15.5893L9.99996 11.1785L5.58921 15.5893C5.26378 15.9147 4.73614 15.9147 4.4107 15.5893C4.08527 15.2638 4.08527 14.7362 4.4107 14.4108L8.82145 10L4.4107 5.58928C4.08527 5.26384 4.08527 4.7362 4.4107 4.41076Z" fill="#214359"/>
					</svg>
				</button>
			)}
			{(props.value?.length >= 3 && searchData && (searchData?.team?.length > 0 || suburbsData?.length > 0 || propertiesData?.length > 0)) &&
				<div className='autocomplete-dropdown'>
					{searchData?.team && searchData?.team.map((item: any, index: number) => (
						<button key={index} className='autocomplete-item' onClick={() => {props.setQuery({search: '', agent: item.value})}}>
							<i className="fal fa-user" aria-hidden="true"></i>
							{item.value}
						</button>
					))}
					{suburbsData && suburbsData.map((item: any, index: number) => (
						<button key={index} className='autocomplete-item' onClick={() => {props.setQuery({search: item.value})}}>
							<i className="fal fa-map-pin" aria-hidden="true"></i>
							{item.value}
						</button>
					))}
					{propertiesData && propertiesData.map((item: any, index: number) => (
						<a key={index} className='autocomplete-item' href={item.url}>
							<i className="fal fa-home" aria-hidden="true"></i>
							{item.value}
						</a>
					))}
				</div>
			}
		</div>
	)
}

export default PropertyMap
